export const BagianConstant = [
  { name: "ADM", value: "ADM" },
  { name: "DOKUMEN KONTROL", value: "DOKUMEN KONTROL" },
  { name: "FINISHING", value: "FINISHING" },
  { name: "FINANCE", value: "FINANCE" },
  { name: "GUDANG & EKSPEDISI", value: "GUDANG & EKSPEDISI" },
  { name: "HRD", value: "HRD" },
  { name: "K3", value: "K3" },
  { name: "KEBERSIHAN", value: "KEBERSIHAN" },
  { name: "M Mesin", value: "M Mesin" },
  { name: "M Mold", value: "M Mold" },
  { name: "MR", value: "MR" },
  { name: "PRINTING", value: "PRINTING" },
  { name: "PPIC", value: "PPIC" },
  { name: "PRODUKSI", value: "PRODUKSI" },
  { name: "PURCHASING", value: "PURCHASING" },
  { name: "QC", value: "QC" },
  { name: "SECURITY", value: "Security" },
  { name: "TEKNISI", value: "TEKNISI" },
];

export const tahun = ["2025", "2026", "2027"];

export const bulan = [
  { name: "Januari", value: 1 },
  { name: "Febuari", value: 2 },
  { name: "Maret", value: 3 },
  { name: "April", value: 4 },
  { name: "Mei", value: 5 },
  { name: "Juni", value: 6 },
  { name: "Juli", value: 7 },
  { name: "Agustus", value: 8 },
  { name: "September", value: 9 },
  { name: "Oktober", value: 10 },
  { name: "November", value: 11 },
  { name: "Desember", value: 12 },
];
